import { OrderAPI } from '@certi/shared/api/order/OrderAPI'

export async function getHostedCheckoutUrl(paymentId: string, accessToken: string): Promise<string> {
  const checkoutSession = await OrderAPI.createCheckoutSession(paymentId, accessToken)

  if (!checkoutSession.checkoutUrl) {
    throw new Error('Unable to load secure checkout session')
  }

  return checkoutSession.checkoutUrl
}

export async function redirectToHostedCheckout(paymentId: string, accessToken: string): Promise<void> {
  const checkoutUrl = await getHostedCheckoutUrl(paymentId, accessToken)
  window.location.assign(checkoutUrl)
}
